export const sortingOptionsObject = {
  'relevance': 'Relevance',
  'price-asc': 'Price, Low to High',
  'price-desc': 'Price, High to Low',
}